import{ FC, MouseEventHandler, Modal, CSSProperties, Button } from 'external/react'

type ModalAcceptCancelFooterProps = {
    onCancel: MouseEventHandler<HTMLButtonElement>
    onAccept: MouseEventHandler<HTMLButtonElement>
    className?: string
    style?: CSSProperties
    labels?: {
        accept?: string
        cancel?: string
    }
}

const ModalAcceptCancelFooter : FC<ModalAcceptCancelFooterProps> = (props) => {

    const {className, style, onCancel, onAccept, labels = {}} = props
    const {accept: acceptLabel = 'Aceptar', cancel: cancelLabel = 'Cancelar'} = labels
    return (
        <Modal.Footer className={className} style={style}>
            <Button variant='light'  onClick={onCancel}>{cancelLabel}</Button>
            <Button variant='primary' className='ml-2' onClick={onAccept} >{acceptLabel}</Button>
        </Modal.Footer>
    )
}

export {ModalAcceptCancelFooter as default}